import type { Gender } from "../game/Types";

export interface PlayerIdentity {
  peerId: string;
  name: string;
  gender: Gender;
  location?: PlayerLocation;
  analyticsId?: string;
}

export interface PlayerLocation {
  latitude: number;
  longitude: number;
  city?: string;
  country?: string;
  region?: string;
}

export interface SignalingTransport extends EventTarget {
  readonly connected: boolean;
  readonly sessionToken: string | null;
  connect(identity: PlayerIdentity): Promise<void>;
  setIdentity(identity: PlayerIdentity): void;
  request<T>(event: string, data: object): Promise<T>;
  notify(event: string, data: object): void;
  disconnect(): void;
}

export const SERVER_EVENTS = [
  "signal",
  "lobby:updated",
  "lobby:list-updated",
  "lobby:peer-joined",
  "lobby:peer-left",
  "lobby:join-request",
  "lobby:join-request-cancelled",
  "lobby:join-approved",
  "lobby:join-rejected",
  "lobby:closed",
] as const;

export const emitTransportEvent = (target: EventTarget, name: string, detail: unknown): void => {
  target.dispatchEvent(new CustomEvent(name, { detail }));
};
